import PropTypes from 'prop-types';
import * as S from './Icon.styles';
import IconSource from './IconSource.inner';

const Icon = ({ cursor, height, modifier, name, onClick, variant, width }) => {
  const CurrentIcon = IconSource[`${name}`] || false;
  return (
    CurrentIcon && (
      <S.Icon
        variant={variant}
        cursor={cursor}
        modifier={modifier}
        data-testid={`icon-${name}`}
        onClick={onClick}
      >
        <CurrentIcon width={width} height={height} />
      </S.Icon>
    )
  );
};

Icon.defaultProps = {
  cursor: 'default',
  height: 24,
  modifier: 'regular',
  variant: 'primary',
  width: 24,
};

Icon.propTypes = {
  height: PropTypes.number,
  name: PropTypes.string.isRequired,
  width: PropTypes.number,
  cursor: PropTypes.oneOf(['not-allowed', 'pointer', 'default', 'none']),
  modifier: PropTypes.oneOf(['regular', 'strong', 'weak', 'inverted']),
  variant: PropTypes.oneOf([
    'primary',
    'secondary-1',
    'secondary-2',
    'secondary-3',
    'neutral',
    'danger',
    'warning',
    'info',
    'success',
  ]).isRequired,
  onClick: PropTypes.func,
};

export default Icon;
